export * from './SchoolOnboardingComponentsStyles';